var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{class:_vm.$style.description},[_c('tbody',_vm._l((_vm.list),function(row,idx){return _c('tr',{key:idx},[_c('th',[_vm._v(_vm._s(row[0]))]),_c('td',{domProps:{"innerHTML":_vm._s(_vm.valueWithHighlights(row))}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }